export enum HighlightsTableColumns {
  TITLE = 'title',
  HIGHLIGHT = 'highlight',
}

export enum HIGHLIGHTS_SORT_KEYS {
  TITLE = 'TITLE',
}

export const getTableFields = (t: Function) => [
  {
    value: HighlightsTableColumns.TITLE,
    label: t('Title'),
    sortable: true,
    sortKey: HIGHLIGHTS_SORT_KEYS.TITLE,
  },
  {
    value: HighlightsTableColumns.HIGHLIGHT,
    label: t('Highlight'),
    width: 306,
  },
];
